import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY,
  { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true } }
);

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function authHeaders() {
  const { ensureSession } = await import("./authState");
  const { session } = await ensureSession();
  return { Authorization: `Bearer ${session?.access_token ?? ""}` };
}
